import React, { ReactNode } from "react";
import "./InfoBanner.css";

interface InfoBannerProps {
  icon: ReactNode;
  color?: "blue" | "green" | "yellow" | "red" | "orange";
  children: ReactNode;
  ctaText?: string;
  onCtaClick?: () => void;
}

const InfoBanner: React.FC<InfoBannerProps> = ({
  icon,
  color = "blue",
  children,
  ctaText,
  onCtaClick,
}) => {
  return (
    <div className={`info-banner info-banner-${color}`}>
      <div className="banner-icon">{icon}</div>
      <div className="banner-text">{children}</div>
      {ctaText && onCtaClick && (
        <button
          className={`banner-cta banner-cta-${color}`}
          onClick={onCtaClick}
        >
          {ctaText}
        </button>
      )}
    </div>
  );
};

export default InfoBanner;
